// Icons
import Messages from '@src/v3/assets/svg/messages';
import MyApplication from '@src/v3/assets/svg/myApplication';
import CreditCheck from '@src/v3/assets/svg/creditCheck';
import Home from '@src/v3/assets/svg/home';
import ProfileIcon from '../assets/svg/profileIcon';
import { getUserType } from '../utils/localStorage';
import { ZEME_USERS_ROLE } from './configs';
import Global from '../assets/svg/global';
import CRM from '@src/v3/assets/svg/crm';
import Heart from '../assets/svg/heart';
import Hamburger from '../assets/svg/hamburger';

export const APP_ROUTE = {
  HOME: '/',
  PUBLIC_PROPERTY: '/property/',
  EXPLORE: '/explore',
  PROPERTY: '/property/#PROPERTY_ID#',
  AGENT_HOME: '/agent/dashboard',
  ANALYTICS: '/analytics',
  SAVED_LISTING: '/saved-listing',
  RENTER_REGISTER: '/auth/renter/register',
  RENTER_REGISTER_PAGE_2: '/register',
  AGENT_REGISTER: '/auth/agent/register',
  LANDLORD_REGISTER: '/auth/landlord/register',
  LOGIN: '/auth/login',
  PROFILE: '/profile/',
  SETTINGS: '/settings',
  EDIT_PROFILE_SETTINGS: '/settings/edit-profile',
  GENERAL_SETTINGS: '/settings/general',
  SUBSCRIPTION_SETTINGS: '/settings/subscription',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_CODE: '/auth/verification-code',
  VERIFY_EMAIL: '/verify-email',
  SUBSCRIPTION: '/auth/subscribe',
  MANUAL_VERIFICATION: '/auth/verification-required',
  VERIFICATION_REQUIRED: '/auth/subscribe/verification-required',
  AI_MARKETING_SETTINGS: '/settings/ai-marketing',

  // Agent routes
  AGENT_DASHBOARD: '/agent/dashboard',
  AGENT_DASHBOARD_CRM: '/agent/dashboard/crm/application',
  AGENT_DASHBOARD_CRM_MARKETING: '/agent/dashboard/crm/marketing',
  AGENT_DASHBOARD_CRM_QUICK_CREDIT: '/agent/dashboard/crm/quickcredit',
  AGENT_DASHBOARD_QUICK_CREDIT: '/agent/dashboard/quick-credit',
  AGENT_ADD_PROPERTY: '/agent/#ID#/add-property',
  AGENT_EXPLORE: '/agent/explore',
  AGENT_MESSAGES: '/agent/chat',
  AGENT_CHAT_WITH_RENTER: '/agent/chat/#RENTER_ID#',
  AGENT_NOTIFICATIONS: '/agent/notifications',
  AGENT_ADD_NEW_PROPERTY: '/property/add',
  AGENT_EDIT_PROPERTY: '/property/#ID#/edit',
  AGENT_MY_APPLICATION: '/agent/property/#PROPERTY_ID#/my-application',
  AGENT_CHAT_ROOM: '/agent/chat/#ROOM_ID#/#PROPERTY_ID#',
  AGENT_CRM_CHAT_ROOM: '/agent/chat/#ROOM_ID#',
  AGENT_SEND_LEASE_MY_APPLICATION:
    '/agent/property/#PROPERTY_ID#/my-application/#APPLICATION_ID#',
  AGENT_PUBLIC_PROFILE: '/agent/profile/#ID#',
  AGENT_PROFILE: '/agent/profile/#USER_IDENTIFIER#',

  // Renter routes
  RENTER_MY_APPLICATION: '/renter/my-application',
  RENTER_MY_APPLICATION_ID: '/renter/my-application/#APPLICATION_ID#',
  RENTER_MESSAGES: '/renter/chat',
  RENTER_CHAT_WITH_AGENT: '/renter/chat/#AGENT_ID#',
  RENTER_CHAT_ROOM: '/renter/chat/#ROOM_ID#/#PROPERTY_ID#',
  INVITE_RENTER: '/user/invite',

  // Privacy & terms
  PRIVACY: '/privacy-policy',
  TERMS: '/terms',
  TU_RENTER_TERMS: '/transunion/renter',
  TU_AGENT_TERMS: '/transunion/agent',

  //One Off Credit
  QUICK_CREDIT: '/applications/quickcredit/',
  ONE_OFF_CREDIT: '/applications/quickcredit/#USER_IDENTIFIER#',

  // Footer routes
  BLOG: '/blog',
  FACEBOOK: 'https://www.facebook.com/zemeapp/',
  INSTAGRAM: 'https://www.instagram.com/zeme.io/',
  TWITTER: 'https://x.com/zeme_io',
  LINKEDIN: 'https://www.linkedin.com/company/zeme-io/',
  RENTERS: '/renters',
  LANDLORDS: '/landlords',
  PROPERTY_MANAGERS: '/property-managers',
  BROKERS: '/brokers',
  AGENTS: '/agents',
  CONTACT: '/support',
  TRUST_CENTER: 'https://trust.zeme.io/',
  STATUS_PAGE: '/status',
};

export const RENTER_ACCESS_ROUTES = [
  APP_ROUTE.EXPLORE,
  APP_ROUTE.RENTER_MY_APPLICATION,
  APP_ROUTE.RENTER_MY_APPLICATION_ID,
  APP_ROUTE.RENTER_MESSAGES,
  APP_ROUTE.RENTER_CHAT_ROOM,
  APP_ROUTE.VERIFY_CODE,
  APP_ROUTE.SETTINGS,
  APP_ROUTE.GENERAL_SETTINGS,
  APP_ROUTE.AGENT_PUBLIC_PROFILE,
  // APP_ROUTE.SAVED_LISTING,
];

export const AGENT_ACCESS_ROUTES = [
  APP_ROUTE.EXPLORE,
  APP_ROUTE.AGENT_DASHBOARD,
  APP_ROUTE.AGENT_DASHBOARD_CRM,
  APP_ROUTE.AGENT_DASHBOARD_CRM_MARKETING,
  APP_ROUTE.AGENT_DASHBOARD_QUICK_CREDIT,
  APP_ROUTE.AGENT_ADD_NEW_PROPERTY,
  APP_ROUTE.AGENT_EDIT_PROPERTY,
  APP_ROUTE.AGENT_MESSAGES,
  APP_ROUTE.AGENT_MY_APPLICATION,
  APP_ROUTE.AGENT_CHAT_ROOM,
  APP_ROUTE.AGENT_CRM_CHAT_ROOM,
  APP_ROUTE.AGENT_SEND_LEASE_MY_APPLICATION,
  APP_ROUTE.VERIFY_CODE,
  APP_ROUTE.SETTINGS,
  APP_ROUTE.GENERAL_SETTINGS,
  APP_ROUTE.SUBSCRIPTION_SETTINGS,
  APP_ROUTE.SUBSCRIPTION,
  APP_ROUTE.MANUAL_VERIFICATION,
  APP_ROUTE.VERIFICATION_REQUIRED,
  APP_ROUTE.AI_MARKETING_SETTINGS,
  APP_ROUTE.AGENT_PUBLIC_PROFILE,
  APP_ROUTE.AGENT_CHAT_WITH_RENTER,
  APP_ROUTE.EDIT_PROFILE_SETTINGS,
  APP_ROUTE.AGENT_DASHBOARD_CRM_QUICK_CREDIT,
];

export const NAVBAR_ROUTES = [
  {
    label: 'Explore',
    value: APP_ROUTE.EXPLORE, //TODO: ICONS need's to be update yet.
    isVisible: true,
    isVisibleBadge: false,
  },
  // {
  //   label: 'About Us',
  //   value: APP_ROUTE.HOME,
  //   isVisible: true,
  //   isVisibleBadge: false,
  // },
  {
    label: 'Saved',
    value: APP_ROUTE.SAVED_LISTING,
    isVisible: true,
    isVisibleBadge: false,
  },
];

export const MOBILE_NAVBAR_ROUTES = [
  {
    label: 'Saved',
    value: APP_ROUTE.SAVED_LISTING,
    isVisible: true,
    isVisibleBadge: false,
    icon: Heart,
  },
  {
    label: 'Home',
    value: APP_ROUTE.EXPLORE,
    isVisible: true,
    isVisibleBadge: false,
    icon: Home,
  },
  {
    label: 'Profile',
    value: APP_ROUTE.SETTINGS,
    isVisible: true,
    isVisibleBadge: false,
    icon: ProfileIcon,
  },
];

export const AGENT_ROUTES = [
  {
    label: 'Home',
    value: APP_ROUTE.AGENT_HOME,
    icon: Home,
    isVisible: true,
    isVisibleBadge: false,
  },
  {
    label: 'Explore',
    value: APP_ROUTE.EXPLORE, //TODO: ICONS need's to be update yet.
    icon: Global,
    isVisible: true,
    isVisibleBadge: false,
  },
  {
    label: 'Messages',
    value: APP_ROUTE.AGENT_MESSAGES,
    icon: Messages,
    isVisible: true,
    isVisibleBadge: true,
  },
  {
    label: 'CRM',
    value: APP_ROUTE.AGENT_DASHBOARD_CRM, //TODO: ICONS need's to be update yet.
    icon: MyApplication,
    isVisible: true,
    isVisibleBadge: false,
  },
  {
    label: 'Quick Credit',
    value: APP_ROUTE.AGENT_DASHBOARD_QUICK_CREDIT,
    icon: CreditCheck,
    isVisible: true,
    isVisibleBadge: false,
  },
];

export const AGENT_MOBILE_ROUTES = [
  {
    label: 'Home',
    value: APP_ROUTE.AGENT_HOME,
    icon: Home,
    isVisible: true,
    isVisibleBadge: false,
  },
  {
    label: 'Explore',
    value: APP_ROUTE.EXPLORE, //TODO: ICONS need's to be update yet.
    icon: Global,
    isVisible: true,
    isVisibleBadge: false,
  },
  {
    label: 'CRM',
    value: APP_ROUTE.AGENT_DASHBOARD_CRM, //TODO: ICONS need's to be update yet.
    icon: CRM,
    isVisible: true,
    isVisibleBadge: false,
  },
  {
    label: 'Messages',
    value: APP_ROUTE.AGENT_MESSAGES,
    icon: Messages,
    isVisible: true,
    isVisibleBadge: true,
  },
  {
    label: 'Profile',
    value: APP_ROUTE.SETTINGS,
    icon: ProfileIcon,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: false,
  },
];

export const RENTER_ROUTES = [
  {
    label: 'Explore',
    value: APP_ROUTE.EXPLORE, //TODO: ICONS need's to be update yet.
    icon: Global,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: true,
  },
  {
    label: 'Saved',
    value: APP_ROUTE.SAVED_LISTING, //TODO: ICONS need's to be update yet.
    icon: Heart,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: true,
  },
  {
    label: 'Applications',
    value: APP_ROUTE.RENTER_MY_APPLICATION,
    icon: MyApplication,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: true,
  },
  {
    label: 'Messages',
    value: APP_ROUTE.RENTER_MESSAGES,
    icon: Messages,
    isVisible: true,
    isVisibleBadge: true,
    isVisibleInHeader: true,
  },
  {
    label: 'Profile',
    value: APP_ROUTE.SETTINGS,
    icon: ProfileIcon,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: false,
  },
];

export const RENTER_MOBILE_ROUTES = [
  {
    label: 'Applications',
    value: APP_ROUTE.RENTER_MY_APPLICATION,
    icon: Hamburger,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: true,
  },
  {
    label: 'Saved',
    value: APP_ROUTE.SAVED_LISTING, //TODO: ICONS need's to be update yet.
    icon: Heart,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: true,
  },
  {
    label: 'Home',
    value: APP_ROUTE.EXPLORE, //TODO: ICONS need's to be update yet.
    icon: Home,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: true,
  },
  {
    label: 'Messages',
    value: APP_ROUTE.RENTER_MESSAGES,
    icon: Messages,
    isVisible: true,
    isVisibleBadge: true,
    isVisibleInHeader: true,
  },
  {
    label: 'Profile',
    value: APP_ROUTE.SETTINGS,
    icon: ProfileIcon,
    isVisible: true,
    isVisibleBadge: false,
    isVisibleInHeader: false,
  },
];

/**
 * This Array is used for setting screen's sidebar options.
 */
export const SETTINGS_SIDEBAR = () => [
  {
    label: 'Edit Profile',
    pageTitle: 'Edit Profile',
    value: APP_ROUTE.EDIT_PROFILE_SETTINGS,
    icon: 'userIcon',
    isVisible: true,
    isCollapse: false,
    collapse: [],
  },
  {
    label: 'General Settings',
    pageTitle: 'General Settings',
    value: APP_ROUTE.GENERAL_SETTINGS,
    icon: 'settingsIcon',
    isVisible: true,
    isCollapse: false,
    collapse: [],
  },
  {
    label: 'Billing',
    pageTitle: 'Billing',
    value: APP_ROUTE.SUBSCRIPTION_SETTINGS,
    icon: 'transactionIcon',
    isVisible:
      getUserType() === ZEME_USERS_ROLE.AGENT ||
      getUserType() === ZEME_USERS_ROLE.LANDLORD,
    isCollapse: false,
    collapse: [],
  },
  {
    label: 'AI Marketing',
    pageTitle: 'AI Marketing',
    value: APP_ROUTE.AI_MARKETING_SETTINGS,
    icon: 'aiMarketingIcon',
    isVisible:
      getUserType() === ZEME_USERS_ROLE.AGENT ||
      getUserType() === ZEME_USERS_ROLE.LANDLORD,
    isCollapse: false,
    collapse: [],
  },
];

/**
 * Footer navigation columns for landing page
 */
export const FOOTER_COLUMNS = [
  {
    title: 'Socials',
    links: [
      // {
      //   label: 'Blog',
      //   value: APP_ROUTE.BLOG,
      //   isVisible: true,
      //   isExternal: true,
      // },
      {
        label: 'Facebook',
        value: APP_ROUTE.FACEBOOK,
        isVisible: true,
        isExternal: true,
      },
      {
        label: 'Instagram',
        value: APP_ROUTE.INSTAGRAM,
        isVisible: true,
        isExternal: true,
      },
      {
        label: 'Twitter / X',
        value: APP_ROUTE.TWITTER,
        isVisible: true,
        isExternal: true,
      },
      {
        label: 'LinkedIn',
        value: APP_ROUTE.LINKEDIN,
        isVisible: true,
        isExternal: true,
      },
    ],
  },
  // {
  //   title: 'Products',
  //   links: [
  //     {
  //       label: 'Renters',
  //       value: APP_ROUTE.RENTERS,
  //       isVisible: true,
  //       isExternal: true,
  //     },
  //     {
  //       label: 'Landlords',
  //       value: APP_ROUTE.LANDLORDS,
  //       isVisible: true,
  //       isExternal: true,
  //     },
  //     {
  //       label: 'Property Managers',
  //       value: APP_ROUTE.PROPERTY_MANAGERS,
  //       isVisible: true,
  //       isExternal: true,
  //     },
  //     {
  //       label: 'Brokers',
  //       value: APP_ROUTE.BROKERS,
  //       isVisible: true,
  //       isExternal: true,
  //     },
  //     {
  //       label: 'Agents',
  //       value: APP_ROUTE.AGENTS,
  //       isVisible: true,
  //       isExternal: true,
  //     },
  //   ],
  // },
  {
    title: 'Support',
    links: [
      {
        label: 'Contact Us',
        value: APP_ROUTE.CONTACT,
        isVisible: true,
        isExternal: true,
      },
      {
        label: 'Terms of Service',
        value: APP_ROUTE.TERMS,
        isVisible: true,
        isExternal: true,
      },
      {
        label: 'Privacy Policy',
        value: APP_ROUTE.PRIVACY,
        isVisible: true,
        isExternal: true,
      },
    ],
  },
  {
    title: 'Security',
    className: 'col-span-2',
    links: [
      {
        label: 'Trust Center',
        value: APP_ROUTE.TRUST_CENTER,
        isVisible: true,
        isExternal: true,
      },
      // {
      //   label: 'Status Page',
      //   value: APP_ROUTE.STATUS_PAGE,
      //   isVisible: true,
      //   isExternal: false,
      // },
    ],
  },
];
